
import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { RevenueSplit } from '@/hooks/license/resellerPlans/types';
import RevenueSplitTableRow from './RevenueSplitTableRow';

interface RevenueSplitTableProps {
  revenueSplits: RevenueSplit[];
  handleUpdateMasterPercentage: (id: string, value: number) => void;
  handleUpdateResellerPercentage: (id: string, value: number) => void;
  onUpdateRevenueSplit: (id: string, updates: Partial<RevenueSplit>) => void;
  onDeleteRevenueSplit: (id: string) => void;
}

const RevenueSplitTable: React.FC<RevenueSplitTableProps> = ({
  revenueSplits,
  handleUpdateMasterPercentage,
  handleUpdateResellerPercentage,
  onUpdateRevenueSplit,
  onDeleteRevenueSplit
}) => {
  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Volume Threshold</TableHead>
            <TableHead>Master License %</TableHead>
            <TableHead>Reseller %</TableHead>
            <TableHead>Status</TableHead>
            <TableHead>Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {revenueSplits.length === 0 ? (
            <TableRow>
              <TableCell colSpan={5} className="text-center py-4 text-muted-foreground">
                No revenue splits found. Click 'Add Split Tier' to create one.
              </TableCell>
            </TableRow>
          ) : (
            [...revenueSplits]
              .sort((a, b) => a.volumeThreshold - b.volumeThreshold)
              .map((split) => (
                <RevenueSplitTableRow
                  key={split.id}
                  split={split}
                  handleUpdateMasterPercentage={handleUpdateMasterPercentage}
                  handleUpdateResellerPercentage={handleUpdateResellerPercentage}
                  onUpdateRevenueSplit={onUpdateRevenueSplit}
                  onDeleteRevenueSplit={onDeleteRevenueSplit}
                />
              ))
          )}
        </TableBody>
      </Table>
    </div>
  );
};

export default RevenueSplitTable;
